import React from 'react'
import { color } from '@figma/fpl-tokens/tokens.stylex'
import {
  authReferralSignupEligible,
  authReferralSignupLearnMore,
  authReferralSignupUnavailable,
} from '@figma/i18n-dictionaries/en/web/auth'
import { tx } from '@web/i18n/react'
import stylex from '@web/lib/stylex'

import type { ReferralSignupStatusOption } from 'shared/auth/auth_models'
import { AuthLink } from 'shared/auth/views/auth_view/auth_link'
import { REFERRAL_TERMS_URL } from 'shared/components/ai_credit_referral/constants'

/**
 * Tells a visitor who arrived through a referral link whether its bonus credits will apply.
 * Rendered as the auth form's status message. The copy is written for the referral_v1 program;
 * see UserReferrals::SignupPreview on the server.
 */
export function ReferralSignupMessage({
  referralStatus,
}: {
  referralStatus: ReferralSignupStatusOption
}) {
  const { eligible, credit_amount: creditAmount } = referralStatus
  return (
    <span {...stylex.props(!eligible && styles.unavailable)} data-testid="referral-signup-message">
      {eligible
        ? tx(authReferralSignupEligible, {
            creditAmount,
            learnMoreLink: (
              <AuthLink href={REFERRAL_TERMS_URL} newTab>
                {tx(authReferralSignupLearnMore)}
              </AuthLink>
            ),
          })
        : tx(authReferralSignupUnavailable, { creditAmount })}
    </span>
  )
}

const styles = stylex.create({
  unavailable: {
    color: color.textDanger,
  },
})
